import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DashboardT } from 'business/definitions';
import { trackEvent } from 'helpers/trackerHelpers';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';
import { ACTIVE_DASHBOARDS_QUERY_KEY } from './getDashboardsList';

const createDashboard = async (title: string) => {
    const response = await RQAPICallWithData<DashboardT>({
        endpoint: `explore/dashboards`,
        body: { title },
        method: 'POST',
    });
    return response.content;
};

/**
 * RQ Mutation to create a new dashboard.
 * The mutation takes as a parameter the title of the new dashboard.
 * @param {(dashboard: DashboardT) => void} onSuccess - A callback function to be executed on success
 */
export const useCreateDashboard = (onSuccess?: (arg1: DashboardT) => void) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: ({ title }: { title: string }) => createDashboard(title),

        onSuccess: ({ data: createdDashboard, message }) => {
            trackEvent('decision/new-dashboard-created');
            queryClient.setQueryData(
                [ACTIVE_DASHBOARDS_QUERY_KEY],
                (oldDashboards: DashboardT[]) => [
                    ...oldDashboards,
                    createdDashboard,
                ],
            );
            dispatch.vision.notifyUser({ message });
            if (onSuccess) onSuccess(createdDashboard);
        },
    });
};
